/* ==========================================================================
   ATÖLYE — kaydırmalı sahne

   Kaydırma ELE GEÇİRİLMEZ. Referans sitelerin trackpad'de "kayıyor/takılıyor"
   hissi vermesinin sebebi scroll hijack'tir. Biz yalnızca sayfanın kendi
   kaydırmasını OKUYORUZ; kullanıcı her an istediği yere gidebilir.

   Kareler ilerlemeye göre seçilir (Apple'ın ürün sayfası yöntemi). WebGL yok,
   3B model yok — maliyet bir avuç JPEG.
   ========================================================================== */

(() => {
  const kur = (kok) => {
    if (kok.dataset.atlReady === "1") return;
    kok.dataset.atlReady = "1";

    const yol = kok.querySelector(".atl-sahne__yol");
    const kutu = kok.querySelector("[data-atl-kareler]");
    const kareler = [...kok.querySelectorAll(".atl-sahne__kare")];
    const yazilar = [...kok.querySelectorAll("[data-atl-beat]")];
    const cubuk = kok.querySelector("[data-atl-cubuk]");
    if (!yol || !kareler.length) return;

    const azalt = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let gorunur = false, bekleyen = false, sonKare = -1;
    const sinirla = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);

    const olc = () => {
      bekleyen = false;
      const r = yol.getBoundingClientRect();
      const vh = innerHeight || 1;
      const toplam = Math.max(1, r.height - vh);
      const p = sinirla(-r.top / toplam);

      kok.style.setProperty("--atl-sahne-ilerleme", p.toFixed(4));
      if (cubuk) cubuk.style.transform = `scaleX(${p.toFixed(4)})`;

      // İlerleme -> kare. Son kare p=1'de tam olarak görünsün diye -1 ile çarpılır.
      const i = Math.min(kareler.length - 1, Math.round(p * (kareler.length - 1)));
      if (i !== sonKare) {
        sonKare = i;
        kareler.forEach((k, n) => k.classList.toggle("is-on", n === i));
      }

      // Yazı vuruşları kendi aralıklarında açılır.
      const yuzde = p * 100;
      yazilar.forEach((y) => {
        const bas = Number(y.dataset.bas) || 0;
        const bit = Number(y.dataset.bit) || 100;
        y.classList.toggle("is-on", yuzde >= bas && yuzde <= bit);
      });
    };

    const istek = () => {
      if (bekleyen || !gorunur) return;
      bekleyen = true;
      requestAnimationFrame(olc);
    };

    // ---- Sıralı ön yükleme ----
    // Hepsini birden "eager" yapmak felaket: 12 tam boy JPEG aynı anda iner,
    // tarayıcı boğulur ve kaydırma kilitlenir. Ölçtüm: sayfa yanıt vermez oldu.
    // Bunun yerine SIRAYLA, biri bitmeden diğerine geçmeden indiriyoruz ve
    // decode() ile çözülmesini bekliyoruz — ilk gösterimde jank olmaz.
    let indirildi = false;
    const indir = async () => {
      if (indirildi) return;
      indirildi = true;
      for (const k of kareler) {
        if (k.complete && k.naturalWidth) continue;
        k.loading = "eager";
        try {
          // decode(): karar verilmiş çözme. Kare ilk kez gösterildiğinde
          // tarayıcı çözmekle uğraşmaz, hazır bekler.
          await (k.decode ? k.decode() : Promise.resolve());
        } catch {
          /* bozuk kare sırayı durdurmasın */
        }
      }
    };

    new IntersectionObserver((g) => {
      gorunur = g.some((x) => x.isIntersecting);
      if (gorunur) { indir(); istek(); }
    }, { rootMargin: "60% 0px" }).observe(yol);

    if (kutu) kutu.classList.add("is-live");
    if (azalt) {
      // Hareket azaltma: kare taraması yok, ilk kare ve tüm yazılar sabit.
      kareler[0].classList.add("is-on");
      yazilar.forEach((y) => y.classList.add("is-on"));
      return;
    }

    addEventListener("scroll", istek, { passive: true });
    addEventListener("resize", istek, { passive: true });
    gorunur = true;
    olc();
  };

  const baslat = () => document.querySelectorAll("[data-atl-sahne]").forEach(kur);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", baslat, { once: true });
  else baslat();
  document.addEventListener("shopify:section:load", baslat);
})();
